import React, { useRef } from 'react';

const useTimer = () => {
  const time = useRef(0);

  const initTimer = () => {
    time.current = +new Date();
  };

  const getTime = () => {
    return +new Date() - time.current;
  };

  const publicAPI = { initTimer, getTime };

  return publicAPI;
};

export default useTimer;
